export const PR_MANAGERS_META_DESCRIPTION =
  "Perceptica gives PR managers media listening, reputation analysis and crisis monitoring across SEE. Stay ahead of every story before it breaks.";
